import { MY_PROFILE_PAGE_LINK, ROLES_PAGE_LINK, TENANTS_PAGE_LINK, USERS_PAGE_LINK } from './links';
import { NavbarGroupItemTypes } from '../../types';
import { PERMISSIONS_MENU } from './variables';

export const navigationConfig: NavbarGroupItemTypes[] = [
  {
    key: 'managements',
    title: 'navigation.management.title',
    type: 'group',
    children: [
      {
        key: 'my-profile',
        title: 'navigation.management.my-profile',
        type: 'item',
        icon: 'fa fa-solid fa-address-card',
        url: MY_PROFILE_PAGE_LINK,
      },
      {
        key: 'users',
        title: 'navigation.management.users-title',
        type: 'item',
        icon: 'fa fa-solid fa-user',
        url: USERS_PAGE_LINK,
        permissions: PERMISSIONS_MENU.USER_ACCOUNT,
      },
      {
        key: 'roles',
        title: 'navigation.management.roles-title',
        type: 'item',
        icon: 'fa fa-solid fa-user-check',
        url: ROLES_PAGE_LINK,
        permissions: PERMISSIONS_MENU.ROLE,
      },
      {
        key: 'tenants',
        title: 'navigation.management.tenants-title',
        type: 'item',
        icon: 'fa fa-solid fa-people-group',
        url: TENANTS_PAGE_LINK,
        permissions: PERMISSIONS_MENU.TENANT,
      },
    ],
  },
];
